
export default [
    {
        path: '/publicPage/serviceProtectionDedicatedFund',
        name: 'serviceProtectionDedicatedFund',
        component: () => import(/* webpackChunkName: "common" */ './index.vue'),
        meta: {
            authPass: true,
            title: '保障服务专款专用',
            headerId: 'myFortune'
        }
    },
   
];
